import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import './App.css';
import Notfound from "./pages/appcontent/Notfound";
import Comingsoon from "./pages/appcontent/Comingsoon";
import PrivateComponent from "./private/PrivateComponent";
import { Login } from "./pages/auth/Login";
import { FAQs } from "./pages/appcontent/FAQs";
import { Aboutus } from "./pages/appcontent/Aboutus";
import { Termsofuse } from "./pages/appcontent/Termsofuse";
import { Privacypolicy } from "./pages/appcontent/Privacypolicy";
import { Dashboard } from "./pages/dashboard/Dashboard";
import { Profile } from "./pages/dashboard/Profile";
import { Userlisting } from "./pages/users/Userlisting";
import { Userdetails } from "./pages/users/Userdetails";
import { DepositWithdrawal } from "./pages/depositwithdrawal/DepositWithdrawal";
import { DepositWithdrawalDetails } from "./pages/depositwithdrawal/DepositWithdrawalDetails";
import { Notifications } from "./pages/notifications/Notifications";
import { AddNotification } from "./pages/notifications/AddNotification";
import { OrdersListing } from "./pages/orders/OrdersListing";
import { OrderDetails } from "./pages/orders/OrderDetails";
import { AccountMetrics } from "./pages/reports/AccountMetrics";
import { TopFundedAccounts } from "./pages/reports/TopFundedAccounts";
import { TopTradingStocks } from "./pages/reports/TopTradingStocks";
import { ClosedPositions } from "./pages/reports/ClosedPositions";
import { Earnings } from "./pages/earnings/Earnings";
import { Contactus } from "./pages/contactus/Contactus";
import { Replymessage } from "./pages/contactus/Replymessage";
import { Faqslisting } from "./pages/faqs/Faqslising";
import { Aboutcms } from "./pages/cmscontent/Aboutcms";
import { Aboutcmsupdate } from "./pages/cmscontent/Aboutcmsupdate";
import { Privacycms } from "./pages/cmscontent/Privacycms";
import { Privacycmsupdate } from "./pages/cmscontent/Privacycmsupdate";
import { Termscms } from "./pages/cmscontent/Termscms";
import { Termscmsupdate } from "./pages/cmscontent/Termscmsupdate";
import { Addfaq } from "./pages/faqs/Addfaq";
import { Editfaq } from "./pages/faqs/Editfaq";
import { Userslist } from "./pages/appcontent/Userslist";
import ChartPage from "./pages/charts/ChartPage";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <>
      <BrowserRouter basename={""}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Comingsoon />} />
          <Route path="tradingcharts/:user_id/:type/:symbol" element={<ChartPage />} />
          <Route path="/success" element={<Comingsoon />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route path="/terms-of-use" element={<Termsofuse />} />
          <Route path="/users-listing" element={<Userslist />} />
        </Routes>
      </BrowserRouter>
      <BrowserRouter basename={'/authpanel'}>
        <AuthProvider>
        <Routes>
          {/* Auth Panel (Private Routes) */}
          <Route element={<PrivateComponent />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/users/listing" element={<Userlisting />} />
            <Route path="/users/view/:user_id" element={<Userdetails />} />
            <Route path="/deposit-withdrawal/listing" element={<DepositWithdrawal />} />
            <Route path="/deposit-withdrawal/view/:user_id" element={<DepositWithdrawalDetails />} />
            <Route path="/notifications/listing" element={<Notifications />} />
            <Route path="/notifications/add" element={<AddNotification />} />
            <Route path="/orders/listing" element={<OrdersListing />} />
            <Route path="/orders/view/:order_id" element={<OrderDetails />} />
            <Route path="/reports/account-metrics" element={<AccountMetrics />} />
            <Route path="/reports/top-funded-accounts" element={<TopFundedAccounts />} />
            <Route path="/reports/top-trading-stocks" element={<TopTradingStocks />} />
            <Route path="/reports/closed-positions" element={<ClosedPositions />} />
            <Route path="/earnings/listing" element={<Earnings />} />
            <Route path="/contactus/listing" element={<Contactus />} />
            <Route path="/contactus/reply-message/:contact_id" element={<Replymessage />} />
            <Route path="/faqs/listing" element={<Faqslisting />} />
            <Route path="/faqs/add" element={<Addfaq />} />
            <Route path="/faqs/edit/:faq_id" element={<Editfaq />} />
            <Route path="/app-content/about-us" element={<Aboutcms />} />
            <Route path="/app-content/about-us-update" element={<Aboutcmsupdate />} />
            <Route path="/app-content/privacy-policy" element={<Privacycms />} />
            <Route path="/app-content/update-privacy-policy" element={<Privacycmsupdate />} />
            <Route path="/app-content/terms-of-use" element={<Termscms />} />
            <Route path="/app-content/update-terms-of-use" element={<Termscmsupdate />} />
          </Route>
          
          {/* Redirect unauthenticated users */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Notfound />} />
        </Routes>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;